import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Checkout abandoned", { props: { triggerType: "Tag Added", tag: "cart-abandoned", event: "cart-abandoned" } }],
  ["w1", "auto-wait", "Wait 1 hour", { props: { duration: "1", unit: "hours" } }],
  ["e1", "auto-email", "You left something behind", { props: { subject: "Your cart is waiting" } }],
  ["w2", "auto-wait", "Wait 1 day", { props: { duration: "1", unit: "days" } }],
  ["e2", "auto-email", "Still thinking it over?", { props: { subject: "What our customers say" } }],
  ["w3", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["e3", "auto-email", "10% code — tonight only", { props: { subject: "SAVE10 expires at midnight" } }],
  ["tg", "auto-tag-add", "Tag: cart-recovered", { props: { tag: "cart-recovered" } }],
]);

const def: TemplateDef = {
  slug: "abandoned-cart-recovery",
  name: "Abandoned Cart Recovery",
  category: "E-commerce",
  tagline:
    "A 3-email rescue sequence with escalating urgency and a discount closer.",
  description:
    "A free abandoned-cart recovery template: product and checkout pages feeding a 3-email win-back sequence — gentle reminder, social proof, then a expiring discount. Clone it into FrazzleCRM and every step becomes a real automation.",
  whatsInside: [
    "Sales page → checkout wired to an abandonment trigger",
    "3 recovery emails: reminder (1h), social proof (1d), discount (2d)",
    "A cart-recovered tag so buyers exit the sequence instantly",
    "Purchase completes on a thank-you page that stops the flow",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-facebook", "Facebook Ads", 40, 60),
      node("src2", "traffic-instagram", "Instagram", 40, 220),
      node("sp", "page-sales", "Product page", 360, 140, { props: { price: "$49" } }),
      node("co", "page-checkout", "Checkout", 680, 140, { props: { price: "$49" } }),
      flow("f1", "Cart Rescue", 1000, 40, 420, 850),
      ...seq.nodes,
      node("ty", "page-thankyou", "Order complete", 1520, 340),
      node("n1", "util-note", "Stop condition", 680, 340, {
        notes:
          "Add 'purchased' as a stop tag on the automation — a completed order pulls the contact out of the rescue sequence immediately.",
      }),
    ],
    [
      edge("src1", "sp"),
      edge("src2", "sp"),
      edge("sp", "co"),
      edge("co", "f1"),
      ...seq.edges,
      edge("f1", "ty"),
    ]
  ),
};

export default def;
